import { render, staticRenderFns } from "./DepartureContractManagement.vue?vue&type=template&id=81b72186&scoped=true&"
import script from "./DepartureContractManagement.vue?vue&type=script&lang=js&"
export * from "./DepartureContractManagement.vue?vue&type=script&lang=js&"
import style0 from "./DepartureContractManagement.vue?vue&type=style&index=0&id=81b72186&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b72186",
  null
  
)

export default component.exports